import IntroStep from "../Components/IntroStep";
import SessionContextDistanceField from "./SessionContextDistanceField";
import SessionContextFirstNameField from "./SessionContextFirstNameField";
import SessionContextLastNameField from "./SessionContextLastNameField";
import SessionContextPhoneNumberField from "./SessionContextPhoneNumberField";
import SessionContextPortalButton from "./SessionContextPortalButton";
import SessionContextZipCodeField from "./SessionContextZipCodeField";
import UserAndSessionContextConfirmation from "./UserAndSessionContextConfirmation";
import UserAndSessionContextGreeting from "./UserAndSessionContextGreetings";

const ComposedIntroStep: React.FC = () => {
  return IntroStep({
    GreetingComponent: UserAndSessionContextGreeting,
    ConfirmationComponent: UserAndSessionContextConfirmation,
    FirstNameField: SessionContextFirstNameField,
    LastNameField: SessionContextLastNameField,
    PhoneNumberField: SessionContextPhoneNumberField,
    ZipCodeField: SessionContextZipCodeField,
    DistanceField: SessionContextDistanceField,
    PortalButton: SessionContextPortalButton
  });
};

export default ComposedIntroStep;
